import { render } from "./tuishui.vue?vue&type=template&id=44113da4&scoped=true"
import script from "./tuishui.vue?vue&type=script&lang=js"
export * from "./tuishui.vue?vue&type=script&lang=js"

import "./tuishui.vue?vue&type=style&index=0&id=44113da4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44113da4"]])

export default __exports__